import React from 'react';
import { Layout } from 'react-admin';
import MyAppBar from './MyAppBar';
import AphMenu from './AphMenu';
//import MyNotification from './MyNotification';

const AphLayout = props => {
  return (
    <Layout
      open={false}
      {...props}
      appBar={MyAppBar}
      menu={AphMenu}
       //notification={MyNotification}
    />
  );
};

export default AphLayout;



// WEBPACK FOOTER //
// ./src/components/AphLayout.js